module.exports = __webpack_public_path__ + "352b9ef589adbbefbb9253de4aeaf64f.png";